import React  from "react";
import { Link, useNavigate } from "react-router-dom";
// import FeatherIcon from "feather-icons-react";
import { login02 } from "../../imagepath";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useState } from "react";

import { Eye, EyeOff } from "feather-icons-react/build/IconComponents";
import { apiRequest, setAuthSession } from "../../../api/client";
import LanguageToggle from "../../common/LanguageToggle";
import { useLanguage } from "../../../contexts/LanguageContext";

// import ReactPasswordToggleIcon from 'react-password-toggle-icon';



const Login = () => {
  const { t } = useLanguage();
  const loginLogo = `${process.env.PUBLIC_URL}/pet-logo.jpg`;


  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const trimmedEmail = String(email || '').trim();
    const trimmedPassword = String(password || '').trim();
    if (!trimmedEmail || !trimmedPassword) {
      setError(t('login.required'));
      return;
    }

    setLoading(true);
    try {
      const res = await apiRequest('/auth/login', {
        method: 'POST',
        body: { email: trimmedEmail, password: trimmedPassword },
      });

      const payload = res?.data;
      const user = payload?.user;
      const token = payload?.token;
      const refreshToken = payload?.refreshToken;

      if (!user || !token) {
        throw new Error(t('login.invalidResponse'));
      }
      if (user.role !== 'ADMIN') {
        throw new Error(t('login.adminOnly'));
      }

      setAuthSession({ user, token, refreshToken });
      navigate('/dashboard');
    } catch (err) {
      setError(err?.message || t('login.failed'));
    } finally {
      setLoading(false);
    }
  };


  // let inputRef = useRef();
  // const showIcon = () => <i className="feather feather-eye" aria-hidden="true">
  //   <FeatherIcon icon="eye" />
  // </i>;
  // const hideIcon = () => <i className="feather feather-eye-slash" aria-hidden="true">
  //   <FeatherIcon icon="eye-off" />
  // </i>
  return (
    <>

      {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <div className="col-lg-6 login-wrap">
              <div className="login-sec">
                <div className="log-img">
                  <img
                    className="img-fluid"
                    src={login02}
                    alt="#"
                  />
                </div>
              </div>
            </div>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="admin-login-language">
                    <LanguageToggle />
                  </div>
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="account-logo">
                        <Link to="/dashboard">
                          <img src={loginLogo} className="login-page-logo" alt="#" />
                        </Link>
                      </div>
                      <h2>{t('login.title')}</h2>
                      {/* Form */}
                      <form onSubmit={onSubmit}>
                        <div className="form-group">
                          <label>
                            {t('login.email')} <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            {t('login.password')} <span className="login-danger">*</span>
                          </label>
                          <input
                          type={passwordVisible ? 'password' : ''}
                          className="form-control pass-input"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          className="toggle-password"
                          onClick={togglePasswordVisibility}
                        >
                          {passwordVisible ? <EyeOff className="react-feather-custom" /> : <Eye className="react-feather-custom" />}
                        </span>
                        </div>
                        {/* <div className="forgotpass">
                          <div className="remember-me">
                            <label className="custom_check mr-2 mb-0 d-inline-flex remember-me">
                              {" "}
                              Remember me
                              <input type="checkbox" name="radio" />
                              <span className="checkmark" />
                            </label>
                          </div>
                          <Link to="/forgotpassword">Forgot Password?</Link>
                        </div> */}
                        {error ? (
                          <div className="alert alert-danger" role="alert">
                            {error}
                          </div>
                        ) : null}
                        <div className="form-group login-btn">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? t('login.loggingIn') : t('login.submit')}
                          </button>
                        </div>
                      </form>
                      {/* /Form */}
                      <div className="next-sign">
                       
                        {/* Social Login */}
                        
                        {/* /Social Login */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
